import styled from 'styled-components';
import { COLOR, LAYOUT } from '@styles/theme';

/**
 * White strip below the app header. Route tabs + toolbar share one row; ink bar
 * meets the gray content below. Toolbar-only headers (e.g. CRM) stay centered.
 */
export const SecondaryHeaderStrip = styled.div`
  flex-shrink: 0;
  padding: 0 ${LAYOUT.secondaryHeaderPaddingX}px;
  min-height: 56px;
  display: flex;
  align-items: stretch;
  background: ${COLOR.white};

  .secondary-route-tabs {
    flex: 1;
    min-width: 0;
  }

  > *:not(.secondary-route-tabs) {
    align-self: center;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 56px;
  }
`;
